const locale = {
	APP_TITLE: 'Posta',
	COMPOSE: 'YENİ E-POSTA',
	FOLDERS: 'KLASÖRLER',
	FILTERS: 'FİLTRELER',
	LABELS: 'ETİKETLER',
	NO_MESSAGES: 'Mesajınız bulunmamakta!',
	SEARCH_PLACEHOLDER: 'E-mail yada bir kişi arayın',
	INBOX: 'Gelen Kutusu',
	SENT: 'Gönderilen',
	DRAFTS: 'Taslaklar',
	SPAM: 'Spam gönderiler',
	TRASH: 'Çöp',
	STARRED: 'Yıldızlı',
	IMPORTANT: 'Önemli'
};

export default locale;
